import React from 'react';
import { Pressable, View } from 'react-native';
import { ListItem } from '../../Core/List/ListItem';
import { Typography } from '../../Core/Typography/Typography';
import { IconProps } from '../../Icons/Icons.types';
import { InfoIcon } from '../../Icons/InfoIcon';

export type InfoListItemType = {
  iconComponent?: React.ElementType;
  iconProps?: IconProps;
  subtitle: string;
  title: string;
  onPress?: () => void;
  infoIconVisible?: boolean;
  onInfoIconPress?: () => void;
  className?: string;
};

export const InfoListItem = ({
  iconComponent: IconComponent,
  iconProps,
  subtitle,
  title,
  onPress,
  infoIconVisible,
  onInfoIconPress,
  className,
}: InfoListItemType) => {
  return (
    <ListItem className={className} onPress={onPress}>
      <View className="flex-1 flex-row items-center justify-start">
        <Typography size="small" className="text-neutral-300">
          {subtitle}
        </Typography>
        {infoIconVisible && (
          <Pressable onPress={onInfoIconPress} className="active:opacity-20">
            <InfoIcon className="ml-2" fill="#A4A7C1" />
          </Pressable>
        )}
      </View>
      <View className="flex-1 flex-row items-center justify-end">
        <Typography weight="medium" size="large">
          {title}
        </Typography>
        {IconComponent && (
          <View className="ml-2">
            <IconComponent {...iconProps} />
          </View>
        )}
      </View>
    </ListItem>
  );
};
